
import App from '@/views/constants/app';
import WorkStock from '@/resources/constants/work-stock';
import WorkStockUtils from '@/resources/utils/work-stock';
import { WorkStockItem } from '@/resources/models/work-stock-item';

const state = {
  workStock: [],
  workStockLoading: {
    'LOAD_ALL': false,
    'START_REVIEW': false,
    'END_REVIEW': false,
    'ACCEPT': false,
    'REJECT': false
  }
};

const getters = {
  workStock: state => state.workStock,
  isWorkStockLoading: state => state.workStockLoading['LOAD_ALL'],
  isStartReviewLoading: state => state.workStockLoading['START_REVIEW'],
  isEndReviewLoading: state => state.workStockLoading['END_REVIEW'],
  isAcceptWorkStockLoading: state => state.workStockLoading['ACCEPT'],
  isRejectWorkStockLoading: state => state.workStockLoading['REJECT']
};

const actions = {
  [WorkStock.Actions.LoadAll.START] ({ commit }) {
    WorkStockUtils.LoadAll()
      .then(response => commit(WorkStock.Mutations.SET, response.data));
  },

  [WorkStock.Actions.StartReview.START] ({ commit }, workStockItem) {
    WorkStockUtils.StartReview(workStockItem)
      .then(response => commit(WorkStock.Mutations.UPDATE, response.data));
  },

  [WorkStock.Actions.EndReview.START] ({ commit }, workStockItem) {
    WorkStockUtils.EndReview(workStockItem)
      .then(response => commit(WorkStock.Mutations.UPDATE, response.data));
  },

  [WorkStock.Actions.Accept.START] ({ commit, dispatch }, data) {
    WorkStockUtils.Accept(data)
      .then((response) => {
        commit(WorkStock.Mutations.UPDATE, response.data);
      });
  },

  [WorkStock.Actions.Reject.START] ({ commit }, data) {
    WorkStockUtils.Reject(data)
      .then(response => commit(WorkStock.Mutations.UPDATE, response.data));
  }
};

const mutations = {
  [WorkStock.Mutations.SET] (state, payload) {
    const workStockItems = payload.map(w => {
      return new WorkStockItem(w);
    });

    state.workStock = workStockItems;
  },

  [WorkStock.Mutations.UPDATE] (state, payload) {
    const workStockItem = new WorkStockItem(payload);
    const existingIndex = state.workStock
      .findIndex(w => w.id === workStockItem.id);

    if (existingIndex != null) {
      state.workStock.splice(existingIndex, 1, workStockItem);
    }
  },

  // to-do, make specific again
  [WorkStock.Mutations.IsLoading.CLEAR] (state) {
    state.workStockLoading = {
      'LOAD_ALL': false,
      'START_REVIEW': false,
      'END_REVIEW': false,
      'ACCEPT': false,
      'REJECT': false
    };
  },

  [WorkStock.Mutations.IsLoading.SET] (state, payload) {
    state.workStockLoading[payload.type] = payload.value;
  },

  [App.Mutations.CLEAR] (state) {
    state.workStock = [];
    state.workStockLoading = {
      'LOAD_ALL': false,
      'START_REVIEW': false,
      'END_REVIEW': false,
      'ACCEPT': false,
      'REJECT': false
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
